import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { MONITORING } from './monitoring.token';

@Injectable()
export class MonitoringErrorHandler implements ErrorHandler {
  private readonly monitoring = inject(MONITORING);

  handleError(error: unknown): void {
    // HTTP failures are reported via the HTTP error handling path, not the global handler.
    if (error instanceof HttpErrorResponse) {
      return;
    }
    this.monitoring.captureException((error as { originalError?: unknown })?.originalError ?? error);
  }
}
